import React from "react";

import './Policy.css'

const Policy = () => {
    return (
        <div className="policy-container">
            <div className='header'>
                <div className='text'>OccuProf Protection of Personal Information Policy</div>
                <div className='underline'></div>
            </div>
            <div className="section-title">Purpose</div>
            <div className="content">
            This policy is established to ensure that OccuProf complies with the Protection of Personal Information Act (POPIA) in
    protecting the personal information of Rand Water employees. The policy outlines the measures and procedures
    implemented to safeguard this information and maintain confidentiality.
            </div>
            <div className="section-title">Scope</div>
            <div className="content">
            This policy applies to all employees, contractors, and third-party service providers who process, store, or manage Rand
            Water employees' personal information on behalf of OccuProf.
            </div>
            <div className="section-title">Definitions</div>
            <div className="content">
            - Personal Information: Information relating to an identifiable, natural person, including but not limited to contact
details, demographic details, medical records, and employment information.
- Data Subject: Rand Water employees whose personal information is processed by OccuProf.
- Processing: Any activity concerning personal information, including collection, storage, modification, dissemination, or
destruction.
- Responsible Party: OccuProf, as the entity determining the purpose and means of processing personal information.
            </div>
            <div className="section-title">Guiding Principles</div>
            <div className="content">
            OccuProf commits to the following principles in processing personal information:

4.1 Accountability: Ensure all personal information is processed in compliance with POPIA.

4.2 Processing Limitation: Personal information is processed lawfully, minimally, and only for the purposes it was
collected.

4.3 Purpose Specification: Clearly define and communicate the purpose for collecting personal information.

4.4 Information Quality: Maintain accurate, complete, and up-to-date records.

4.5 Security Safeguards: Protect personal information against unauthorized access, loss, or damage through robust
security measures.

4.6 Data Subject Participation: Allow Rand Water employees to access their personal information and request corrections
or deletions when necessary.
            </div>
            <div className="section-title">Processing of Personal Information</div>
            <div className="content">
            5.1 Collection: OccuProf will collect personal information directly from Rand Water employees unless authorized
otherwise or permitted by law.

5.2 Use and Retention: Personal information will be used solely for occupational health assessments, compliance with
legal obligations, and related purposes. Retention of personal information will be limited to the duration necessary for
these purposes or as required by law.

5.3 Disclosure: OccuProf will not disclose personal information to third parties without the explicit consent of the data
subject unless legally obligated.
            </div>
            <div className="section-title">Security Measures</div>
            <div className="content">
            OccuProf employs the following security measures to safeguard personal information:
- Data encryption and secure storage.
- Controlled access to information based on role and responsibility.
- Regular audits and assessments of data security protocols.
- Employee training on POPIA compliance and data protection practices.
            </div>
            <div className="section-title">Data Subject Rights</div>
            <div className="content">
            Rand Water employees have the following rights under POPIA:
- To be informed about the collection and use of their personal information.
- To access their personal information.
- To request corrections or deletions of inaccurate, irrelevant, or excessive data.
- To object to the processing of their information under certain conditions.
            </div>
            <div className="section-title">Complaints and Breach Management</div>
            <div className="content">
            Complaints: Data subjects may lodge complaints about the handling of their personal information by contacting
OccuProf’s Information Officer at [contact details].

8.2 Breach Management: In the event of a data breach, OccuProf will:
- Notify the Information Regulator and affected data subjects promptly.
- Take immediate steps to contain and mitigate the breach.
- Conduct an investigation to prevent recurrence.
            </div>
            <div className="section-title">Responsibilities</div>
            <div className="content">
            Information Officer: Ensure compliance with POPIA and oversee data protection practices.
            - Employees and Contractors: Adhere to this policy and report any data protection concerns or breaches.
            </div>
            <div className="section-title">Policy Review</div>
            <div className="content">
            This policy will be reviewed annually or as required by changes in legislation or operational needs.
            </div>
            <div className="section-title">Approval and Enforcement</div>
            <div className="content">
            This policy is approved by Dr Nokuthula Khumalo and is enforceable from 05/12/2024. Non-compliance may result in
            disciplinary action or legal consequences.
            </div>
            <div className="section-title">Contact Information</div>
            <div className="content">
            For queries regarding this policy, contact:
Dr Nokuthula Khumalo
Director
082 483 312
tech@occuprof.co.za
            </div>
        </div>
    )
}

export default Policy